import { AxiosError } from 'axios';
import { useState } from 'react';
import { startConnectorUseApi } from '@/api/linkDriveApi';
import {
  StartConnectorUseApiParams,
  StartConnectorUseApiResponse,
} from '@/types/api/linkDriveApi';

const errorMessage =
  'エラーコード：LD0007<br><br>サービス利用を開始できませんでした。お手数ですがお問い合わせフォームからサポートセンターへお問い合わせください。';

export const useStartConnectorUse = () => {
  const [data, setData] = useState<StartConnectorUseApiResponse['data']>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<AxiosError>();
  const startConnectorUse = async (params: StartConnectorUseApiParams) => {
    try {
      setIsLoading(true);
      const { data } = await startConnectorUseApi(params);
      setData(data);
      if (!data.success) throw new Error(errorMessage);
    } catch (err) {
      setError(err as AxiosError);
      throw new Error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isLoading,
    error,
    startConnectorUse,
  };
};
